import {
	instrumentType,
	TrendsOverTimeZoomContent,
	TrendsOverTimeGraphData,
	TrendsOverTimeInstrument,
} from '../model/model'
import { PhoropterSingleEye } from '../model/refraction'

const mapConnectTrendsOverTimeInstruments = (
	instrument: string,
): instrumentType | undefined => {
	switch (instrument) {
		case 'sphere':
			return 'sphere'
		case 'sph_eq':
			return 'spheq'
		case 'add':
			return 'add'
		case 'cylinder':
			return 'cyl'
		case 'iop':
			return 'iop'
		default:
			return
	}
}

const mapConnectTrendsOverTimeSingleEyeData = (
	data: any,
): PhoropterSingleEye => {
	return {
		sphere: data.sphere ?? '',
		add: data.add ?? '',
		axis: data.axis ?? '',
		cyl: data.cylinder ?? '',
		hPrism: data.hPrism ?? '',
		vPrism: data.vPrism ?? '',
		vOrient: '',
		hOrient: '',
	}
}

const mapConnectTrendsOverTimeRefractionData = (
	data: any,
): TrendsOverTimeInstrument => {
	const testData = data.testData.refractions[0]?.dayStandard

	return {
		key: data.updatedAt,
		OD: testData?.OD
			? mapConnectTrendsOverTimeSingleEyeData(testData?.OD)
			: undefined,
		OS: testData?.OS
			? mapConnectTrendsOverTimeSingleEyeData(testData?.OS)
			: undefined,
	}
}

const mapConnectTrendsOverTimeTonometryData = (
	data: any,
): TrendsOverTimeInstrument => {
	return {
		key: data.timestamp.date,
		OD: { iop1: data.OD },
		OS: { iop1: data.OS },
	}
}

const mapConnectTrendsOverTimeContent = (
	content: any,
): TrendsOverTimeGraphData => {
	const instrument = mapConnectTrendsOverTimeInstruments(content.itemId)
	const isTonometeryData = instrument === 'iop'

	return {
		instrument,
		tot: content.data.map((connectTot: any) =>
			isTonometeryData
				? mapConnectTrendsOverTimeTonometryData(connectTot)
				: mapConnectTrendsOverTimeRefractionData(connectTot),
		),
	}
}

export const mapConnectTrendsOverTimeZoomData = (
	content: any,
): TrendsOverTimeZoomContent => {
	return {
		section: 'trends-over-time-zoom',
		content: mapConnectTrendsOverTimeContent(content),
	}
}
